import moment from "moment/moment";
import { GET, POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaAlertaOpcionRespuestaPlaca() {
    try {
        let rows = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-opcion-respuesta-placa/obtener-lista-alerta-opcion-respuesta-placa/",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            for (let i = 0; i < body.length; i++) {
                body[i].fechaProceso = moment(body[i].fechaProceso).format('DD/MM/YYYY HH:mm')
                rows.push(body[i]);
            }
        }
        return rows;
    } catch (err) {
        console.log("obtenerListaAlertaOpcionRespuestaPlaca err");
        console.log(err);
        return [];
    }
}

export async function crearAlertaOpcionRespuestaPlaca(obj) {
    try {
        let creado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-opcion-respuesta-placa/guardar-alerta-opcion-respuesta-placa/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado = true;
        }
        return creado;
    } catch (err) {
        console.log("crearAlertaOpcionRespuestaPlaca err");
        console.log(err);
        return false;
    }
}

export async function modificarAlertaOpcionRespuestaPlaca(obj) {
    try {
        let modificado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-opcion-respuesta-placa/modificar-alerta-opcion-respuesta-placa/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            modificado = true;
        }
        return modificado;
    } catch (err) {
        console.log("modificarAlertaOpcionRespuestaPlaca err");
        console.log(err);
        return false;
    }
}

export async function deshabilitarAlertaOpcionRespuestaPlaca(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-opcion-respuesta-placa/deshabilitar-alerta-opcion-respuesta-placa/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("deshabilitarAlertaOpcionRespuestaPlaca err");
        console.log(err);
        return false;
    }
}
